import mapPin from "../assets/images/Button_Map_Pin.png";

const MapMarker = ({ handleClick }: { handleClick: () => void; lat: number; lng: number }) => {
  return <img className="marker" src={mapPin} alt="map pin" onClick={handleClick}></img>;
};

export default MapMarker;
